import { Box, Stack, Typography, useTheme } from '@mui/material';
import { REQUIRED_COLOR } from '../createForm.styles';

type CreateFormFieldLabelProps = {
	label: string;
	charHint?: string;
	sub?: boolean;
	ltr?: boolean;
};

export const CreateFormFieldLabel = ({ label, charHint, sub, ltr }: CreateFormFieldLabelProps) => {
	const { formTitle, muted, border_teal } = useTheme().palette.root;
	const labelSx = sub
		? { fontSize: '12px !important', color: muted }
		: { fontSize: '13px !important', fontWeight: 500, color: formTitle };

	return (
		<Stack direction="row" alignItems="center" gap={1} flexWrap="wrap" sx={ltr ? { direction: 'ltr' } : undefined}>
			<Typography sx={labelSx}>
				{label}{' '}
				<Box component="span" sx={{ color: REQUIRED_COLOR }}>
					*
				</Box>
			</Typography>
			{charHint && (
				<Typography sx={{ ml: 'auto', fontSize: '11px !important', color: border_teal }}>{charHint}</Typography>
			)}
		</Stack>
	);
};
